/**
 * Mabuhay Designs - Required File Upload Validation
 * BLOCKS Add to Cart until customer uploads their design file
 * Works on: DTF Transfer and Upload Your Own Gang Sheet products
 */
(function() {
  'use strict';

  // Products that REQUIRE file upload before adding to cart
  const REQUIRED_UPLOAD_PRODUCTS = [
    'dtf-transfer-select-your-size',
    'upload-your-own-gang-sheet-22-inches-wide'
  ];

  function init() {
    const currentPath = window.location.pathname;

    // Check if current page requires file upload
    const requiresUpload = REQUIRED_UPLOAD_PRODUCTS.some(handle =>
      currentPath.includes(handle)
    );

    if (!requiresUpload) return;

    console.log('[Mabuhay] File upload validation ACTIVE');

    // Wait for page to fully load
    setTimeout(setupValidation, 500);
  }

  function setupValidation() {
    // Find all Add to Cart buttons
    const addToCartButtons = document.querySelectorAll(
      'button[type="submit"][name="add"], ' +
      '.product-form__submit, ' +
      'button.shopify-payment-button__button, ' +
      '.shopify-payment-button button'
    );

    if (addToCartButtons.length === 0) {
      console.log('[Mabuhay] No add to cart buttons found, retrying...');
      setTimeout(setupValidation, 500);
      return;
    }

    // Find the product form
    const productForm = document.querySelector('form[action*="/cart/add"]') ||
                        document.querySelector('product-form form') ||
                        document.querySelector('.product-form form');

    // Create warning message
    const warningDiv = document.createElement('div');
    warningDiv.id = 'mabuhay-upload-warning';
    warningDiv.innerHTML = `
      <div style="
        background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
        color: white;
        padding: 15px 20px;
        border-radius: 8px;
        margin: 15px 0;
        text-align: center;
        font-weight: 600;
        box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
      ">
        <span style="font-size: 1.3em;">⬆️</span>
        <span style="margin-left: 8px;">Please upload your design file above before adding to cart</span>
      </div>
    `;

    // Create error message (shown when they try to add without upload)
    const errorDiv = document.createElement('div');
    errorDiv.id = 'mabuhay-upload-error';
    errorDiv.style.cssText = `
      background: #dc3545;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      margin: 15px 0;
      text-align: center;
      font-weight: 600;
      display: none;
      animation: shake 0.5s ease-in-out;
    `;
    errorDiv.innerHTML = '🚫 <strong>FILE REQUIRED!</strong> You must upload your design file before adding to cart.';

    // Insert messages before the first add to cart button
    const buttonContainer = addToCartButtons[0].closest('.product-form__buttons') ||
                           addToCartButtons[0].parentElement;

    if (buttonContainer) {
      buttonContainer.insertBefore(errorDiv, buttonContainer.firstChild);
      buttonContainer.insertBefore(warningDiv, buttonContainer.firstChild);
    }

    // Function to check if file has been uploaded
    function isFileUploaded() {
      // Method 1: Check file input directly
      const fileInputs = document.querySelectorAll('input[type="file"]');
      for (const input of fileInputs) {
        if (input.files && input.files.length > 0) {
          return true;
        }
      }

      // Method 2: Check for hidden inputs with file URLs (upload apps store URLs here)
      const hiddenInputs = document.querySelectorAll('input[type="hidden"]');
      for (const input of hiddenInputs) {
        const val = input.value || '';
        if (val.includes('cdn.shopify.com/s/files') ||
            val.includes('ucarecdn.com') ||
            val.includes('uploadcare') ||
            val.includes('cloudinary') ||
            (val.includes('http') && (val.includes('.png') || val.includes('.jpg') || val.includes('.jpeg') || val.includes('.pdf')))) {
          return true;
        }
      }

      // Method 3: Check for properties inputs with file values
      const propertyInputs = document.querySelectorAll('input[name*="properties"]');
      for (const input of propertyInputs) {
        const val = input.value || '';
        if (val.includes('cdn.shopify.com') ||
            val.includes('ucarecdn') ||
            val.includes('.png') ||
            val.includes('.jpg') ||
            val.includes('.pdf')) {
          return true;
        }
      }

      // Method 4: Check for VISIBLE uploaded file indicators (must be visible, not just in DOM)
      const uploadedIndicators = document.querySelectorAll(
        '[class*="uploaded"], ' +
        '[class*="file-preview"], ' +
        '[class*="upload-success"], ' +
        '[data-uploaded="true"], ' +
        '.uploadcare--widget__button_type_remove'
      );
      for (const indicator of uploadedIndicators) {
        // Check if element is actually visible
        const styles = window.getComputedStyle(indicator);
        const isVisible = styles.display !== 'none' &&
                         styles.visibility !== 'hidden' &&
                         indicator.offsetWidth > 0 &&
                         indicator.offsetHeight > 0;
        if (isVisible) {
          return true;
        }
      }

      // Method 5: Check if Remove button is visible (means file was uploaded)
      const removeButtons = document.querySelectorAll('button, a');
      for (const btn of removeButtons) {
        const text = btn.textContent?.toLowerCase() || '';
        const isVisible = btn.offsetParent !== null &&
                         !btn.hasAttribute('hidden') &&
                         btn.style.display !== 'none';
        if (isVisible && (text === 'remove' || text === 'remove file' || text === 'delete')) {
          return true;
        }
      }

      // Method 6: Check for image preview elements
      const previews = document.querySelectorAll(
        '[class*="preview"] img, ' +
        '[class*="thumbnail"] img, ' +
        '.upload-preview img'
      );
      for (const preview of previews) {
        if (preview.src && preview.src.includes('http')) {
          return true;
        }
      }

      return false;
    }

    // Function to update UI based on upload status
    function updateUI() {
      const uploaded = isFileUploaded();

      if (uploaded) {
        warningDiv.style.display = 'none';
        errorDiv.style.display = 'none';
        addToCartButtons.forEach(btn => {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
        });
        console.log('[Mabuhay] File detected - Add to Cart ENABLED');
      } else {
        warningDiv.style.display = 'block';
        addToCartButtons.forEach(btn => {
          btn.style.opacity = '0.6';
          btn.style.cursor = 'not-allowed';
        });
        console.log('[Mabuhay] No file detected - Add to Cart shows warning');
      }

      return uploaded;
    }

    // Block form submission if no file
    function blockSubmit(e) {
      if (!isFileUploaded()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        warningDiv.style.display = 'none';
        errorDiv.style.display = 'block';
        errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Shake animation
        errorDiv.style.animation = 'none';
        setTimeout(() => { errorDiv.style.animation = 'shake 0.5s ease-in-out'; }, 10);

        console.log('[Mabuhay] BLOCKED - No file uploaded!');
        return false;
      }
      return true;
    }

    // Add click interceptors to all buttons
    addToCartButtons.forEach(btn => {
      btn.addEventListener('click', blockSubmit, true);
    });

    // Also intercept form submission
    if (productForm) {
      productForm.addEventListener('submit', blockSubmit, true);
    }

    // Watch for all forms on page
    document.querySelectorAll('form').forEach(form => {
      if (form.action && form.action.includes('/cart')) {
        form.addEventListener('submit', blockSubmit, true);
      }
    });

    // Monitor for file upload changes
    const observer = new MutationObserver(() => {
      updateUI();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'class', 'style', 'src', 'data-uploaded']
    });

    // Also watch file inputs
    document.querySelectorAll('input[type="file"]').forEach(input => {
      input.addEventListener('change', () => {
        setTimeout(updateUI, 200);
      });
    });

    // Add CSS for shake animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-8px); }
        20%, 40%, 60%, 80% { transform: translateX(8px); }
      }
      #mabuhay-upload-error {
        animation: shake 0.5s ease-in-out;
      }
    `;
    document.head.appendChild(style);

    // Initial UI update
    updateUI();

    // Periodic check (backup)
    setInterval(updateUI, 2000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
